import { render, staticRenderFns } from "./ButtonText.vue?vue&type=template&id=de02cce8&scoped=true&"
import script from "./ButtonText.vue?vue&type=script&lang=js&"
export * from "./ButtonText.vue?vue&type=script&lang=js&"
import style0 from "./ButtonText.vue?vue&type=style&index=0&id=de02cce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de02cce8",
  null
  
)

export default component.exports